module.exports = __webpack_public_path__ + "static/media/map.32575baa.png";